function moveComponentModals(): void {
  const modals = document.querySelectorAll<HTMLElement>('.component-modal');
  const modalWrapper = document.querySelector<HTMLElement>('.modal-wrapper');

  modals.forEach(modal => {
    modalWrapper.appendChild(modal);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  moveComponentModals();
});
